import { Dispatch, SetStateAction } from 'react';
import {
  applyAdjustTableChanges,
  closeAdjustTable,
  openAdjustTable,
  resetAdjustTableChanges,
} from '../components/TableInternal.helpers';
import { UseColumnConfigResult } from './useColumnConfig';

interface UseAdjustTableHandlersParams {
  id: string;
  columnIdKey: string;
  columnConfig?: UseColumnConfigResult;
  setColumnOrder: (id: string, columnIdKey: string, columnOrder: string[]) => void;
  resetColumnState: (id: string, columnIdKey: string) => void;
  setIsAdjustTableOpen: Dispatch<SetStateAction<boolean>>;
}

interface UseAdjustTableHandlersResult {
  handleAdjustTableClick: () => void;
  handleAdjustTableClose: () => void;
  handleAdjustTableApply: (newOrder: string[], hasOrderChanged: boolean) => Promise<void>;
  handleAdjustTableReset: () => Promise<void>;
}

export const useAdjustTableHandlers = ({
  id,
  columnIdKey,
  columnConfig,
  setColumnOrder,
  resetColumnState,
  setIsAdjustTableOpen,
}: UseAdjustTableHandlersParams): UseAdjustTableHandlersResult => {
  const handleAdjustTableClick = () => openAdjustTable(columnConfig, setIsAdjustTableOpen);

  const handleAdjustTableClose = () => closeAdjustTable(columnConfig, setIsAdjustTableOpen);

  const handleAdjustTableApply = async (newOrder: string[], hasOrderChanged: boolean) =>
    applyAdjustTableChanges({
      newOrder,
      hasOrderChanged,
      id,
      columnIdKey,
      setColumnOrder,
      columnConfig,
      setIsAdjustTableOpen,
    });

  const handleAdjustTableReset = async () =>
    resetAdjustTableChanges({
      id,
      columnIdKey,
      resetColumnState,
      columnConfig,
      setIsAdjustTableOpen,
    });

  return {
    handleAdjustTableClick,
    handleAdjustTableClose,
    handleAdjustTableApply,
    handleAdjustTableReset,
  };
};
